import { alpha, Button, useTheme } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { negativeTrendColorState, positiveTrendColorState } from 'states';

interface BuySellBtnProps {
  onClick: () => void;
  isBuy: boolean;
}

const BuySellBtn = ({ onClick, isBuy }: BuySellBtnProps) => {
  const theme = useTheme();
  const serverPosColor = useRecoilValue(positiveTrendColorState);
  const serverNegColor = useRecoilValue(negativeTrendColorState);

  return (
    <Button
      size="small"
      variant="contained"
      onClick={onClick}
      sx={{
        minWidth: { xs: '60px', lg: 'auto' },
        position: 'relative',
        color: theme.palette.getContrastText(
          isBuy ? serverPosColor : serverNegColor,
        ),
        backgroundColor: isBuy ? serverPosColor : serverNegColor,
        '&:after': {
          content: '"⇄"',
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          color: theme.palette.getContrastText(
            isBuy ? serverNegColor : serverPosColor,
          ),
          backgroundColor: isBuy ? serverNegColor : serverPosColor,
          borderRadius: '50%',
          width: '20px',
          height: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        },
        '&:hover': {
          transform: 'scale(1.05)',
          transition: 'transform 0.2s',
          backgroundColor: isBuy
            ? alpha(serverPosColor, 0.9)
            : alpha(serverNegColor, 0.9),
        },
      }}
    >
      {isBuy ? 'BTO' : 'STO'}
    </Button>
  );
};

export default BuySellBtn;
